module.exports = __webpack_public_path__ + "static/logo.9bcc8f4f.png";


//////////////////
// WEBPACK FOOTER
// /Users/grantmaclennan/code/_archive/Toos/src/images/logo.png
// module id = 69
// module chunks = 0